// Generated by ReScript, PLEASE EDIT WITH CARE


function scrollTargetTop(rootTop, targetTop, currentScrollTop, padding) {
  return currentScrollTop + (targetTop - rootTop - padding);
}

function scrollNotebookToSection(sectionId) {
  var target = document.getElementById("section-" + sectionId);
  if (target == null) {
    return ;
  }
  var scrollRoot = document.getElementById("notebook-scroll");
  if (scrollRoot == null) {
    return ;
  }
  var rootRect = scrollRoot.getBoundingClientRect();
  var targetRect = target.getBoundingClientRect();
  var top = scrollTargetTop(rootRect.top, targetRect.top, scrollRoot.scrollTop, 12.0);
  scrollRoot.scrollTo({
        top: top,
        behavior: "smooth"
      });
}

function mounted() {
  var self = this ;
  var element = self.el;
  var onClick = function ($$event) {
    var target = $$event.target;
    if (target == null) {
      return ;
    }
    var button = target.closest("[data-toc-section]");
    if (button == null) {
      return ;
    }
    if (!element.contains(button)) {
      return ;
    }
    var id = button.getAttribute("data-toc-section");
    if (!(id == null)) {
      $$event.preventDefault();
      return scrollNotebookToSection(id);
    }
    
  };
  self.handleClick = onClick;
  element.addEventListener("click", onClick);
}

function destroyed() {
  var self = this ;
  self.el.removeEventListener("click", self.handleClick);
}

var NotebookToc = {
  mounted: mounted,
  destroyed: destroyed
};

export {
  scrollTargetTop ,
  scrollNotebookToSection ,
  mounted ,
  destroyed ,
  NotebookToc ,
}
/* mounted Not a pure module */
